export default {
    data() {
        return {
            // 搜索表单数据
            form: {
                // 问题内容
                problemContent: '',
                // 课程名称
                courseName: '',
                // 试题类型
                questionType: '',
                // 正确答案
                correctAnswer: '',
                // 参考章节
                referChapter: '',
                // 是否随机题
                random: false,
                // 是否禁用
                disable: false,
                // 备注
                remark: '',
            },
            // 课程数据
            courseList: [
                {
                    label: '高铁用高性能混凝土的研究',
                    value: '1',
                },
                {
                    label: '高铁用高性能混凝土的研究',
                    value: '2',
                },
                {
                    label: '高铁用高性能混凝土的研究',
                    value: '3',
                },
                {
                    label: '高铁用高性能混凝土的研究',
                    value: '4',
                },
            ],
            // 试题类型
            questionTypes: [
                {
                    label: '单选题',
                    value: '单选题',
                },
                {
                    label: '多选题',
                    value: '多选题',
                },
                {
                    label: '判断题',
                    value: '判断题',
                },
            ],
            // 表格数据
            tableData: [
                {
                    id: 1,
                    courseName: '道路交通事故致人损害的侵权责任',
                    questionType: '判断题',
                    problemContent: '是不是是不是是不是？？？？？？？',
                    optionA: '对',
                    optionB: '错',
                    optionC: '',
                    optionD: '',
                    optionE: '',
                    correctAnswer: '对',
                    random: 'true',
                    disable: '否',
                    referChapter: '',
                    remark: '',
                },
                {
                    id: 2,
                    courseName: '道路交通事故致人损害的侵权责任',
                    questionType: '判断题',
                    problemContent: '是不是是不是是不是？？？？？？？',
                    optionA: '对',
                    optionB: '错',
                    optionC: '',
                    optionD: '',
                    optionE: '',
                    correctAnswer: '对',
                    random: 'true',
                    disable: '否',
                    referChapter: '',
                    remark: '',
                },
                {
                    id: 3,
                    courseName: '道路交通事故致人损害的侵权责任',
                    questionType: '判断题',
                    problemContent: '是不是是不是是不是？？？？？？？',
                    optionA: '对',
                    optionB: '错',
                    optionC: '',
                    optionD: '',
                    optionE: '',
                    correctAnswer: '对',
                    random: 'true',
                    disable: '否',
                    referChapter: '',
                    remark: '',
                },
            ],
            // 导入试题对话框
            importCourseDialog: false,
            // 已选择的表格行
            selections: [],
            // 已选择的表格行的id
            selectionIds: [],
            // 下载导入模板
            download: '',
            // 上传的试题导入地址
            address01: '',
            // 新增试题对话框
            addNewQuestionDialog: false,
            // 新增的试题数据
            addform: {
                courseName: '',
                questionType: '',
                problemContent: '',
                optionA: '',
                optionB: '',
                optionC: '',
                optionD: '',
                optionE: '',
                correctAnswer: '',
                random: false,
                disable: false,
                referChapter: '',
                remark: '',
            },
            // 修改试题对话框
            editQuestionDialog: false,
            // 修改的试题数据
            editform: {
                courseName: '',
                questionType: '',
                problemContent: '',
                optionA: '',
                optionB: '',
                optionC: '',
                optionD: '',
                optionE: '',
                correctAnswer: '',
                random: false,
                disable: false,
                referChapter: '',
                remark: '',
            },
            // 总条数
            total: 20,
            // 当前页
            currentPage: 1,
            // 每页显示条数
            pageSize: 10,
        }
    },
    methods: {
        // 搜索
        search() {

        },

        // 当选择项发生变化时会触发该事件
        handleSelectionChange(selections) {
            this.selections = selections;
            // 取出选择的表格行的id
            this.selectionIds = selections.map(item => item.id);
        },

        // 批量导入试题
        httpreq01(q) {
            this.$upload(this.address01, q).then(res => {
                this.$message({
                    message: '导入试题完成',
                    type: 'success'
                });
            });
        },

        // 点击新增试题按钮
        handleNewQuestion() {
            this.addNewQuestionDialog = true;
        },

        // 确定新增试题
        addNewQuestion() {
            this.addNewQuestionDialog = false;
            this.$message.success('新增成功！');
        },

        // 点击修改试题按钮
        handleEditQuestion() {
            // 先判断是否有选择记录且最多选择一条记录
            if (this.selectionIds.length === 0 || this.selectionIds.length !== 1) {
                this.$message.warning('抱歉！请选择一条记录！');
                return;
            }
            this.editQuestionDialog = true;

            // 发送请求获取数据
            this.editform = {
                id: 3,
                courseName: '道路交通事故致人损害的侵权责任',
                questionType: '判断题',
                problemContent: '是不是是不是是不是？？？？？？？',
                optionA: '对',
                optionB: '错',
                optionC: '',
                optionD: '',
                optionE: '',
                correctAnswer: '对',
                random: true,
                disable: true,
                referChapter: '',
                remark: '备注备注',
            }
        },

        // 确认修改试题
        editQuestion() {
            this.editQuestionDialog = false;
            this.$message.success('修改成功！');
        },

        // 点击删除按钮
        handleDeleteQuestion() {
            // 先判断是否有选择记录
            if (this.selectionIds.length === 0) {
                this.$message.warning('抱歉！请选择一条记录！');
                return;
            }
            this.$message.success('删除成功！');
        },

        // 每页显示条数改变时调用
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
        },

        // 当前页改变时调用
        handleCurrentChange(currentPage) {
            this.currentPage = currentPage;
        },
    }
}